import angular from 'angular'
import template from './template.html'

angular.module('nominas.nomina')
  .component('nominaOperadoraDepositosNuevo', {
    template: template,
    controller: NominaOperadoraDepositosNuevoComponent,
    bindings: {
      idEmpresa: '<',
      idNomina: '<',
      depositado: '<',
      pendiente: '<',
      onChange: '&',
    },
  })

function NominaOperadoraDepositosNuevoComponent($q, NominaOperadoraCuentasbancarias, NominaSaCuentasbancarias, NominaOperadoraDepositos, NominaComisionistasOperadora, NominaOperadoraIngreso, $filter) {
  let $ctrl = this
  $ctrl.$onInit = $onInit
  $ctrl.aceptar = aceptar
  $ctrl.agregar = agregar
  $ctrl.cancelar = cancelar
  $ctrl.recalcularImporte = recalcularImporte

  function $onInit() {
    $ctrl.agregando = false
    $ctrl.actualizando = false
    $ctrl.iva = 0
    $ctrl.comision_op = 0
  }

  function aceptar() {
    let data = {
      id_cuenta_sa: $ctrl.data.cuenta_sa.id_cuenta,
      id_cuenta_op: $ctrl.data.cuenta_op.id_cuenta,
      fecha_deposito: $ctrl.data.fecha_deposito,
      importe: $ctrl.data.importe,
    }

    $ctrl.actualizando = true

    return NominaOperadoraDepositos.post($ctrl.idEmpresa, $ctrl.idNomina, data)
      .then(function (response) {
        $ctrl.onChange({$event: {data: response.data}})
        $ctrl.agregando = false
      })
      .finally(function () {
        $ctrl.actualizando = false
      })
  }

  function agregar() {
    $ctrl.agregando = true
    $ctrl.data = undefined
    $ctrl.incluirIva = true
    $ctrl.incluirComisionOp = true
    $ctrl.inicial = $ctrl.depositado === 0

    if (!$ctrl.promise)
      $ctrl.promise = $q.all([
        NominaSaCuentasbancarias.get($ctrl.idEmpresa, $ctrl.idNomina)
          .then(function (response) {
            $ctrl.cuentasSa = $filter('orderBy')(response.data, ['moneda', 'banco', 'cuenta'])
            $ctrl.cuentaSaPredeterminada = $ctrl.cuentasSa.find(function (item) {
              return item.predeterminado
            })
          }),
        NominaOperadoraCuentasbancarias.get($ctrl.idEmpresa, $ctrl.idNomina)
          .then(function (response) {
            $ctrl.cuentasOp = $filter('orderBy')(response.data, ['moneda', 'banco', 'cuenta'])
            $ctrl.cuentaOpPredeterminada = $ctrl.cuentasOp.find(function (item) {
              return item.predeterminado
            })
          }),
        $ctrl.inicial ? NominaComisionistasOperadora.get($ctrl.idEmpresa, $ctrl.idNomina)
          .then(function (response) {
            $ctrl.comision_op = response.data.comision_importe || 0
          })
          : null,
        $ctrl.inicial ? NominaOperadoraIngreso.get($ctrl.idEmpresa, $ctrl.idNomina)
          .then(function (response) {
            $ctrl.iva = response.data.iva
          })
          : null,
      ])

    $ctrl.promise.then(function () {
      $ctrl.edicionManual = $ctrl.inicial === false

      $ctrl.data = {
        cuenta_sa: $ctrl.cuentaSaPredeterminada,
        cuenta_op: $ctrl.cuentaOpPredeterminada,
        fecha_deposito: new Date(),
        importe: $ctrl.pendiente,
      }
    })
  }

  function cancelar() {
    $ctrl.agregando = false
  }

  function recalcularImporte() {
    $ctrl.data.importe = $ctrl.pendiente
      - ($ctrl.incluirIva ? 0 : $ctrl.iva)
      - ($ctrl.incluirComisionOp ? 0 : $ctrl.comision_op)
  }
}



// WEBPACK FOOTER //
// ./src/nominas/nomina/components/operadora/depositos/nuevo/component.js